import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface TabPanelProps {
    boxProps?: Partial<BoxProps>;
    children?: React.ReactNode;
    index: string | number;
    value: null | string | number;
}

export default function TabPanel(props: TabPanelProps) {
    const { boxProps, children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={'16px 0px 0px 16px'} {...(boxProps || {})}>
                    {children}
                </Box>
            )}
        </div>
    );
}
